import { useState } from "react";
import { Box } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { BookingMatching } from "./booking-matching/booking-matching";
import { DeclaredConsultants } from "./declared-consultants/declared-consultants";

type Props = {
  customerId: string;
};

export function ConsultantMatching(props: Props) {
  const [selectedTab, setSelectedTab] = useState("bookings");

  return (
    <Box>
      <Box mb={2}>
        <ToggleButtonGroup
          value={selectedTab}
          exclusive
          onChange={(event, value) => setSelectedTab(value)}
        >
          <ToggleButton value="bookings" data-test="BookingMatchingButton">
            Bokade
          </ToggleButton>

          <ToggleButton value="workExperience" data-test="DeclaredConsultantsButton">
            Deklarerade
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {selectedTab === "bookings" && <BookingMatching customerId={props.customerId} />}

      {selectedTab === "workExperience" && (
        <DeclaredConsultants customerId={props.customerId} />
      )}
    </Box>
  );
}
